export const clubFilterOptions = {
  eventType: {
    label: 'Event Type',
    values: [
      // Sprints
      '60m',
      '70m',
      '100m',
      '200m',
      '300m',
      '400m',
      // Distance
      '500m',
      '700m',
      '800m',
      '1500m',
      '3000m',
      '5000m',
      // Hurdles
      '60m Hurdles',
      '80m Hurdles',
      '90m Hurdles',
      '100m Hurdles',
      '110m Hurdles',
      '200m Hurdles',
      '300m Hurdles',
      '400m Hurdles',
      'Play Hurdles',
      // Relays
      '4x60m',
      '4x70m',
      '4x100m',
      '4x200m',
      '4x400m',
      '4x50m Shuttle',
      '4x70m Shuttle',
      '4x100m Shuttle',
      // Walks
      '300m Walk',
      '500m Walk',
      '700m Walk',
      '1100m Walk',
      '1500m Walk',
      // Field - Jumps
      'High Jump',
      'Long Jump',
      'Triple Jump',
      'Floppy Jump',
      // Field - Throws
      'Discus',
      'Javelin',
      'Shot Put',
      'Vortex',
    ], // order must match server SortOrder (the catalogue, EventTypeCatalogue.cs); the Club Records page orders by it
  },
  trackSurface: {
    label: 'Track Surface',
    values: ['Synthetic', 'Grass'],
  },
  ageGroup: {
    label: 'Age Group',
    values: [
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      'Seniors',
      'Masters',
    ], // even though technically u14-17 is one age group that competes together, records go by age so keep seperate
  },
  gender: {
    label: 'Gender',
    values: ['Female', 'Male'],
  },
  timestamp: {
    label: 'Date',
    type: 'date', // make a date indicator because we have to handle differently and it needs to know when
    sortFunction: (dates) => {
      return dates.sort((a, b) => new Date(b) - new Date(a)); // sort it descending so the most recent is first
    },
  },
};
